<template>
  <div
    class="fixed text-lg rounded-full z-10 bottom-5 end-5 h-9 w-9 text-center bg-red-cc text-white leading-9 cursor-pointer"
    v-show="showTopButton"
  >
    <a @click="scrollToTop" id="back-to-top"
      ><i class="mdi mdi-arrow-up"></i
    ></a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showTopButton: false,
    }
  },
  created() {
    window.addEventListener('scroll', this.handleScroll)
  },
  unmounted() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      if (
        document.body.scrollTop >= 250 ||
        document.documentElement.scrollTop >= 250
      ) {
        this.showTopButton = true
      } else {
        this.showTopButton = false
      }
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
  },
}
</script>

<style lang="scss" scoped>
.btn-scroll-to-top {
  position: fixed;
  bottom: 5%;
  right: 30px;
  z-index: 99;

  opacity: 0;
  // transform: translateY(100px);
  transition: all 0.5s ease;

  &.show {
    opacity: 1;
    // transform: translateY(0)
  }
}
</style>
